export const SIDE_MENU_ITEM = Object.freeze({
	HOME				: {
		id		: 0,
		label : "Home"
	},

	CAMPAIGNS		: {
		id		: 1,
		label : "Campanhas"
	},

	MY_PROFILE	: {
		id		: 2,
		label : "Meu Perfil"
	},

	PARAMETER_SLOT	: {
		id		: 3,
		label : "Parametrizar Slots"
	},

	
	INSTITUTIONAL_SCREENS: {
        id    : 4,
        label : "Telas Institucionais"
    },

	
	REGISTRY_SEARCH: {
        id    : 5,
        label : "Consulta de Cadastros"
    },

	CONTAINMENT_BUTTON: {
		id		: 6,
		label : "Botão de Contenção"
	}
});

export const SIDE_MENU_ITEMS = [
	{
		...SIDE_MENU_ITEM.HOME,
		orderById	: 0,
		enabled		: true
	},

	{
		...SIDE_MENU_ITEM.CAMPAIGNS,
		orderById	: 1,
		enabled		: true
	},

	{
		...SIDE_MENU_ITEM.MY_PROFILE,
		orderById	: 2,
		enabled		: true
	},
	{
		...SIDE_MENU_ITEM.PARAMETER_SLOT,
		orderById	: 3,
		enabled		: true
	},

	
	{
        ...SIDE_MENU_ITEM.INSTITUTIONAL_SCREENS,
        orderById : 4,
        enabled   : true
    },

	
	{
        ...SIDE_MENU_ITEM.REGISTRY_SEARCH,
        orderById : 5,
        enabled   : true
    },


	{
		...SIDE_MENU_ITEM.CONTAINMENT_BUTTON,
		orderById	: 6,
		enabled		: true
	}
]